export default __webpack_public_path__ + "static/media/angus-beef.67061873.png";